<template>
  <li class="dropdown dropdown-wrapper">
    <nav-link :badge-count="activeCallbacks.length" @link-click="onClick()" data-toggle="dropdown" data-placement="top"
              title="Terugbelverzoeken">
      <phone-icon></phone-icon>
    </nav-link>

    <div @click.stop="" class="dropdown-menu tasks pull-right text-left">
      <div class="no-callbacks" v-if="activeCallbacks.length === 0 ">
        Geen actieve belverzoeken
      </div>
      <template v-else-if="activeCallbacks.length > 0">
        <ul class="callbacks-list">
          <UserTaskComponent
            v-for="task of activeCallbacks"
            :key="task.id"
            :task="task"
            @fetch-callbacks="fetchCallbacks"></UserTaskComponent>
        </ul>


        <!-- TODO: Implement department callbacks when single API endpoint has been made for callbacks (and department callbacks) -->
      </template>
      <div style="padding: 5px;" v-if="hasVoip">
        <div v-if="isAvailable">
          <a-button v-on:click="setStatus(VoipStatusEnum.AVAILABLE)">
            Zet op beschikbaar
          </a-button>
        </div>
        <div v-else>
          <a-button v-on:click="setStatus(VoipStatusEnum.DO_NOT_DISTURB)">
            Zet op niet-storen
          </a-button>
        </div>
      </div>
    </div>
  </li>

</template>

<script>
import UserTaskComponent from "./UserTaskComponent.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import taskStore from "../../modules/task/store";
import voipStore from "../../modules/voip/store";
import VoipStatusEnum from "~/enums/VoipStatusEnum";
import NavLink from './NavLink.vue';

export default {
  name: "PhoneDropdownComponent.vue",
  data() {
    return {
      STORE_KEY: "$_activeCallbacks",
      isCollapsed: true,
      VoipStatusEnum: VoipStatusEnum
    };
  },
  created() {
    let TASK_STORE_KEY = "$_activeCallbacks";

    // eslint-disable-next-line no-underscore-dangle
    if (!(TASK_STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(TASK_STORE_KEY, taskStore);
    }

    let VOIP_STORE_KEY = "$_voip";

    // eslint-disable-next-line no-underscore-dangle
    if (!(VOIP_STORE_KEY in this.$store._modules.root._children)) {
      this.$store.registerModule(VOIP_STORE_KEY, voipStore);
    }


    this.fetchStatus();
    this.fetchCallbacks();
  },
  components: {
    UserTaskComponent,
    NavLink
  },
  computed: {
    ...mapGetters({
      activeCallbacks: "$_activeCallbacks/activeCallbacks",
      status: "$_voip/status",

    }),
    ...mapState({
      user: "me"
    }),
    hasVoip() {
      return this.user.voip_extension !== null;
    },
    isAvailable() {
      return this.status === VoipStatusEnum.AVAILABLE;
    }
  },
  methods: {
    ...mapActions({
      fetchActiveCallbacks: "$_activeCallbacks/fetchActiveCallbacksTasks",
      fetchStatus: "$_voip/fetchStatus",
      setStatus: "$_voip/setStatus",
      getMe: 'getMe',
    }),
    fetchCallbacks() {
      this.fetchActiveCallbacks(this.user.id, 1, 5);
    },
    onClick() {
      this.isCollapsed = !this.isCollapsed;
      if (this.isCollapsed && this.activeCallbacks.length !== 0) {
        this.fetchActiveCallbacks(this.user.id);
      }
    }
  },
  props: {
    userTasks: {
      type: Array,
      required: true
    },
    departmentTasks: {
      type: Array,
      required: true
    },
    departments: {
      type: Array,
      required: true
    }
  }
};
</script>

<style lang="scss" scoped>
@import "~@/_default.scss";

.dropdown-wrapper {
  position: relative;
}

.dropdown-menu {
  right: 0;
  width: 550px;
  margin-top: $spacing-md;
  background-color: $main-content-bg-color;
  padding: 0;
}

.callbacks-department {
  min-width: 600px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.no-callbacks {
  padding: $spacing-lg;
  text-align: center;
  color: $brand-primary;
}

.callbacks-list {
  padding-left: 0;
  width: 100%;

}
</style>
